import css from './shell.module.css'
import { useTheme } from '../app/theme'
import { useAuth } from '../app/AuthProvider'

/**
 * Brand, kill switch, theme and account. Navigation left for `SideNav` when it
 * moved to a left rail: the top bar does not survive a growing set of views.
 *
 * The "Mobile view" toggle in the prototype is a prototype affordance and does
 * not exist here; the phone layout is media queries and the real thing.
 */
export function Header() {
  const { theme, toggle } = useTheme()
  const { initials, email, displayName, signOut } = useAuth()

  return (
    <header className={css.header}>
      <div className={css.headerInner}>
        <div className={css.brand}>
          <img src="/logo-white.png" alt="" height={28} style={{ width: 'auto' }} />
          <span className={css.brandName}>Robotica</span>
        </div>

        <div className={css.headerRight}>
          {/* Pausing the fleet has to stop the systemd timer claiming runs. That
              is a runner change, and this app holds select on three tables and
              one function. Disabled and honest beats a button that lies. */}
          <button
            className={css.killSwitch}
            disabled
            title="Not wired up. Pausing the fleet has to stop the runner claiming work, which is a change in the runner rather than here."
          >
            Fleet running
          </button>
          <button
            className={css.headerGhost}
            onClick={toggle}
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
          >
            {theme === 'dark' ? 'Light' : 'Dark'}
          </button>
          <button
            className={css.avatar}
            onClick={() => void signOut()}
            title={`${displayName ?? email ?? 'Signed in'} — sign out`}
            aria-label="Sign out"
          >
            {initials}
          </button>
        </div>
      </div>
    </header>
  )
}
